import Search from '@/docs-partials/api/endpoints/search.mdx';
import * as React from 'react';
export default {
  Search,
  React
};